import { BASE_PATH_API } from '@root/manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';
import { ProjectTemplateDto } from '@app/projects/data/dto/project-template-dto';
import { CreateUpdateProjectTemplateTaskDTO } from '@root/app/projects/data/dto/create-update-project-template-task-dto';

const routeRoot = 'v1/projectTemplateTasks';
const baseRoute = `${BASE_PATH_API}/${routeRoot}`;

const actions = {
    createProjectTemplateTask: {
        method: 'POST',
        url: baseRoute,
    },
    getProjectTemplateTasks: {
        method: 'GET',
        url: `${baseRoute}/project/:id`,
        params: {
            '$count': true
        }
    },
    updateProjectTemplateTask: {
        method: 'PUT',
        url: `${baseRoute}/:id`
    },
    deleteProjectTemplateTask: {
        method: 'DELETE',
        url: `${baseRoute}/:id`
    }
};

export interface IProjectTemplateTasksApi {
    createProjectTemplateTask(CreateProjectTemplateTaskDto: CreateUpdateProjectTemplateTaskDTO): Promise<ProjectTemplateDto>;
    getProjectTemplateTasks(params: { id: number }): Promise<any>;
    updateProjectTemplateTask(params: { id: number }, updateProjectTemplateTaskDto: CreateUpdateProjectTemplateTaskDTO): Promise<ProjectTemplateDto>;
    deleteProjectTemplateTask(params: { id: number }): Promise<any>;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function ProjectTemplateTasksApi(): IProjectTemplateTasksApi {
    return createActions(actions);
}
